import React, { memo, forwardRef } from 'react';
import Indicator from './complexityLevelIndicator';

import { COMPLEXITY_LEVEL_INDEX_MAP } from '@model/questionmaires';

import PropTypes from 'prop-types';
import ComplexityGaugeIndicator from '@modules/questionnaires/complexity/complexityGaugeIndicator';

const getContentComponent = (Content, props = {}) => {
  if (Content?.$$typeof) {
    return React.cloneElement(Content, props);
  } else if (typeof content === 'function') {
    return <Content {...props} />;
  }
  return Content;
};

const Arrow = ({ isExpanded }) => (
  <span
    className={`appkiticon a-font-12 icon-up-chevron-fill ${
      isExpanded ? 'down' : ''
    }`}
  />
);

function ReportCard({
  level,
  content,
  onChange,
  isEditing,
  value = {},
  title,
  size,
  noBorder,
  className,
  showArrow,
  isExpanded,
  noHeader,
  formKey,
  noLevel,
  titlePropName,
  selectMode,
  onLevelSelectChange,
  handleGaugeChange,
  useGauge = false,
  showSubSection,
}) {
  return (
    <section
      className={`complexity-report-card ${
        className ? className : ''
      } ${size} ${noBorder ? 'no-border' : ''} ${useGauge ? 'use-gauge' : ''}`}
    >
      {!noHeader && (
        <div className="complexity-report-card-header">
          {(value[titlePropName] || title) && (
            <div className="complexity-report-card-title-wrapper">
              {showArrow && <Arrow isExpanded={isExpanded} />}
              <div className="complexity-report-card-title">
                {(value[titlePropName] || title) === 'BPSI'
                  ? 'BPSI (Business Processes & Systems Integration)'
                  : value[titlePropName] || title}
              </div>
            </div>
          )}
          {useGauge && (
            <ComplexityGaugeIndicator
              selectMode={selectMode} // on edit view
              onChange={handleGaugeChange}
              value={value.levelPercent || 0}
              size="small"
              background="#121212"
            />
          )}
          {!noLevel && !useGauge && (
            <Indicator
              withoutColorful
              wholeText
              level={COMPLEXITY_LEVEL_INDEX_MAP[value.level || level]}
              size={size}
              selectMode={selectMode}
              onChange={onLevelSelectChange}
            />
          )}
        </div>
      )}

      <div className={`complexity-report-card-content ${size}`}>
        {getContentComponent(content, { value, onChange, isEditing, formKey })}
      </div>
    </section>
  );
}

ReportCard.defaultProps = {
  title: '',
  size: 'middle',
  noHeader: false,
  level: null,
  titlePropName: '',
  noLevel: false,
  showSubSection: true,
};

ReportCard.propTypes = {
  level: PropTypes.oneOf(['low', 'medium', 'high']),
  content: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  title: PropTypes.string,
  noHeader: PropTypes.bool,
  noLevel: PropTypes.bool,
  titlePropName: PropTypes.string,
  showSubSection: PropTypes.bool,
};

export default memo(forwardRef(ReportCard));
